module.exports = __webpack_public_path__ + "img/profess2.199eff64.png";